import { ChevronRight } from 'lucide-react';
import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { deriveBreadcrumbs } from '@/lib/breadcrumbs';

export const Breadcrumbs = () => {
  const { pathname } = useLocation();
  const crumbs = deriveBreadcrumbs(pathname);

  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex min-w-0 items-center gap-1 text-sm">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <Fragment key={crumb.to}>
            {index > 0 ? <ChevronRight aria-hidden className="size-3.5 shrink-0 text-muted-foreground" /> : null}
            {isLast ? (
              <span aria-current="page" className="truncate font-medium">
                {crumb.title}
              </span>
            ) : (
              <Link className="truncate text-muted-foreground transition-colors hover:text-foreground" to={crumb.to}>
                {crumb.title}
              </Link>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
};
Breadcrumbs.displayName = 'Breadcrumbs';
